<h2 mat-dialog-title class="mat-h2">
  Sample Information@if (data.stageNumber !== null) {
  <span> — Stage {{ data.stageNumber }}</span>
}
<button mat-icon-button class="close-button" type="button" aria-label="Close" (click)="close()">
  <mat-icon>close</mat-icon>
</button>
</h2>
<mat-dialog-content>
  @if (data.probeLabels.length) {
    <div class="sample-table-container">
      <table mat-table [dataSource]="data.probeLabels" class="sample-table">
        <ng-container matColumnDef="sensorNumber">
          <th mat-header-cell *matHeaderCellDef>Sensor</th>
          <td mat-cell *matCellDef="let label">{{ label.sensorNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="sampleId">
          <th mat-header-cell *matHeaderCellDef>Sample ID</th>
          <td mat-cell *matCellDef="let label">{{ label.sampleId }}</td>
        </ng-container>
        <ng-container matColumnDef="inHouseId">
          <th mat-header-cell *matHeaderCellDef>In-House ID</th>
          <td mat-cell *matCellDef="let label">{{ label.inHouseId }}</td>
        </ng-container>
        <ng-container matColumnDef="sampleDescription">
          <th mat-header-cell *matHeaderCellDef>Sample Description</th>
          <td mat-cell *matCellDef="let label">{{ label.sampleDescription }}</td>
        </ng-container>
        <ng-container matColumnDef="projectName">
          <th mat-header-cell *matHeaderCellDef>Project Name</th>
          <td mat-cell *matCellDef="let label">{{ label.projectName }}</td>
        </ng-container>
        <ng-container matColumnDef="projectReference">
          <th mat-header-cell *matHeaderCellDef>Project Reference</th>
          <td mat-cell *matCellDef="let label">{{ label.projectReference }}</td>
        </ng-container>
        <ng-container matColumnDef="tr">
          <th mat-header-cell *matHeaderCellDef class="numeric-cell">TR (°C-cm/W)</th>
          <td mat-cell *matCellDef="let label" class="numeric-cell">{{ formatTr(label.tr) }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  } @else {
    <p>No sample information in this file.</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
